import React, { useState } from "react";
import { FiAlertTriangle, FiAlertCircle, FiInfo } from "react-icons/fi";
import { SeverityBadge, severityColor } from "./aqmHelpers";

const CAT_ICONS = { "CO₂": "🌬", "PM2.5": "🌫", "TVOC": "🧪", "Device": "📡", "AQI": "🔴", "NO₂": "⚗", "PM10": "🌫" };

const AqmAlertsPanel = ({ alerts, mode }) => {
  const [filterSev, setFilterSev] = useState("All");
  const [filterAck, setFilterAck] = useState("All");
  const [selected, setSelected]   = useState(null);

  const filtered = alerts.filter(a => {
    const s = filterSev === "All" || a.severity === filterSev;
    const k = filterAck === "All" || (filterAck === "Unacked" ? !a.ack : a.ack);
    return s && k;
  });

  const critical = alerts.filter(a => a.severity === "Critical").length;
  const warning  = alerts.filter(a => a.severity === "Warning").length;
  const info     = alerts.filter(a => a.severity === "Info").length;
  const unacked  = alerts.filter(a => !a.ack).length;
  const sel = selected ? alerts.find(a => a.id === selected) : null;

  return (
    <div className="aqm-alerts-panel">

      <div className="aqm-alert-summary">
        {[
          { label: "Critical", count: critical, color: "#ef4444", bg: "#fee2e2", icon: FiAlertTriangle },
          { label: "Warning",  count: warning,  color: "#f59e0b", bg: "#fef3c7", icon: FiAlertCircle  },
          { label: "Info",     count: info,     color: "#3b82f6", bg: "#dbeafe", icon: FiInfo         },
          { label: "Unack'd",  count: unacked,  color: "#8b5cf6", bg: "#ede9fe", icon: FiAlertTriangle },
        ].map(s => (
          <div key={s.label} className="aqm-al-sum-card" style={{ borderTopColor: s.color, background: s.bg }}>
            <s.icon size={18} color={s.color} />
            <div className="aqm-als-num" style={{ color: s.color }}>{s.count}</div>
            <div className="aqm-als-lbl">{s.label}</div>
          </div>
        ))}
      </div>

      <div className="aqm-view-row">
        {["All","Critical","Warning","Info"].map(f => (
          <button key={f} className={`aqm-view-btn ${filterSev === f ? "aqm-view-active" : ""}`} onClick={() => setFilterSev(f)}>{f}</button>
        ))}
        <span style={{ margin: "0 8px", color: "#d1d5db" }}>|</span>
        {["All","Unacked","Acked"].map(f => (
          <button key={f} className={`aqm-view-btn ${filterAck === f ? "aqm-view-active" : ""}`} onClick={() => setFilterAck(f)}>{f}</button>
        ))}
      </div>

      <div className="aqm-alerts-body">
        <div className="aqm-alert-list">
          {filtered.map(a => {
            const sc = severityColor(a.severity);
            return (
              <div key={a.id} className={`aqm-alert-card ${a.id === selected ? "aqm-alert-sel" : ""}`}
                style={{ borderLeftColor: sc.color }} onClick={() => setSelected(a.id === selected ? null : a.id)}>
                <div className="aqm-ac-top">
                  <span className="aqm-ac-cat">{CAT_ICONS[a.category] || "⚡"} {a.category}</span>
                  <SeverityBadge severity={a.severity} />
                  <span className="aqm-badge" style={{ background: a.ack ? "#d1fae5" : "#fee2e2", color: a.ack ? "#10b981" : "#ef4444", marginLeft: "auto", fontSize: 10 }}>
                    {a.ack ? "✓ Acked" : "Unack'd"}
                  </span>
                </div>
                <div className="aqm-ac-msg">{a.message}</div>
                <div className="aqm-ac-meta">
                  <span>📍 {a.room || a.station}</span>
                  <span>🕐 {a.time}</span>
                  {a.assignedTo && <span>👤 {a.assignedTo}</span>}
                </div>
              </div>
            );
          })}
          {filtered.length === 0 && <div className="aqm-empty">No alerts match current filter.</div>}
        </div>

        {sel && (
          <div className="aqm-alert-detail">
            <div className="aqm-ad-title">Alert — {sel.id}</div>
            <SeverityBadge severity={sel.severity} />
            <div className="aqm-ad-msg">{sel.message}</div>
            <div className="aqm-ad-grid">
              <div><label>Location</label><span>{sel.room || sel.station}</span></div>
              <div><label>Category</label><span>{sel.category}</span></div>
              <div><label>Time</label><span>{sel.time}</span></div>
              <div><label>Ack'd</label><span>{sel.ack ? `Yes — ${sel.assignedTo}` : "No"}</span></div>
            </div>
            <div className="aqm-ad-actions">
              {!sel.ack && <button className="aqm-ctrl-btn aqm-ctrl-green">✓ Acknowledge</button>}
              <button className="aqm-ctrl-btn aqm-ctrl-blue">👤 Assign Tech</button>
              <button className="aqm-ctrl-btn aqm-ctrl-gray">📧 Notify</button>
            </div>
            {sel.severity === "Critical" && (
              <div className="aqm-ad-ai">
                🤖 AI: {sel.category === "CO₂"
                  ? "Immediately increase HVAC damper and fan speed. If CO₂ > 1400 ppm, reduce room occupancy."
                  : sel.category === "PM2.5"
                  ? "Activate air purifier and check filter status. Reduce outdoor air intake if outdoor AQI is high."
                  : "Immediate action required. Dispatch maintenance team."}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AqmAlertsPanel;
